export default {
  constructionDocuments: 'Construction Documents',
  objects: 'objektit',
  name: 'Nimi',
  modified: 'Muokattu',
  size: 'Koko',
  loading: 'Ladata...',
  errorMessages: {
    unknownError: 'Jotain meni pieleen. Päivitä sivu!',
    noFilesFound: 'Tälle projektille ei löytynyt tiedostoja tai kansioita.',
    chooseProjectIfs: 'Valitse projekti IFS avataksesi asiakirjat.',
    emptyFolder: 'Tyhjä kansio',
  },
  downloadFileConfirmationModal: {
    title: 'Lataa tiedosto',
    body: 'Oletko varma, että haluat ladata seuraavan tiedoston?',
    cancel: 'Peruuttaa',
    proceed: 'Lataa',
  },
  toast: {
    errorReload: 'Lataa sivu uudelleen ja yritä uudelleen!',
  },
  sharepointExport: {
    sharepointExport: 'Sharepoint-vienti',
    exportAllReady: 'Vie valmistellut',
    refreshHcs: 'Päivitä HCs',
    refresh: 'Päivitä',
    help: 'Apau',
    table: {
      columns: {
        reportType: 'Raporttityyppi',
        totalAmount: 'Kokonaismäärä',
        readyToExport: 'Ei viety',
        status: 'Tila',
        inProgress: 'Jonossa',
        exported: 'Viety',
        failed: 'Epäonnistui (ei viety)',
      },
      reportType: {
        CABINET: 'Jakokaappi',
        WORK_VARIATION: 'Tilauksen muutospyyntö',
        HUB: 'HUB',
        HC: 'HC',
        HP: 'HP',
        LAND_AGREEMENT: 'Maankäyttösopimus',
        LAND_SURVEY: 'Mittaukset',
        SITE: 'Site',
        SPAN: 'Linja',
        MANHOLE: 'Kaivo',
        MDU_BUILDING: 'Rakennus',
        MDU_DELIVERY_POINT: 'Toimituspisteet',
      },
      status: {
        NONE: ' ',
        READY: 'Valmisteltu',
        COMPLETED: 'Valmis',
        IN_PROGRESS: 'Käynnissä',
      },
      exportButton: {
        EXPORTING: 'Käynnissä',
        NOT_READY: 'Vie',
        SOME_READY: 'Vie',
        ALL_COMPLETED: 'Vie',
        ALL_READY: 'Vie',
      },
    },
    helpModal: {
      title: 'Sharepoint-vienti',
      intro: {
        title: 'Vie SharePointiin DeliveryPortalista',
        body: 'Vie valmiit raportit PDF-tiedostoina DeliveryPortalista SharePointiin.',
      },
      howItWorks: {
        title: 'Kuinka se toimii',
        body: 'Voit viedä vain valmiita raportteja (katso alla). Raportit luokitellaan tyypin mukaan, ja voit seurata viennin tilaa taulukossa. Kun viet raportteja, se suoritetaan taustalla. Voit sulkea DeliveryPortalin ja palata myöhemmin tarkistamaan tulokset. Klikkaa "Päivitä" päivittääksesi taulukon – viennin yksityiskohdat eivät päivity automaattisesti.',
      },
      exportableReportsCompleted: {
        title: 'Vietävät raportit (valmiit)',
        body: 'Jokaisella raportilla on erityinen "definition of done", joka kuvaa, mitä tulee olla valmiina ennen viennin aloittamista. Tarkista selitykset jokaiselle raporttityypille.',
        reportType: {
          HP: 'HP - House passed',
          HC: 'HC - House connected',
          CABINET: 'Jakokaappi / FOS',
          MANHOLE: 'Kaivo',
          HUB: 'HUB',
          SITE: 'Site',
          SPAN: 'Linja',
        },
        dod: {
          STATUS_DONE: 'Tila Valmis',
          STATUS_RESTORED: 'Tila Palautettu',
          FILLED_AND_PERFORMED:
            'Kaikki suorituspäivät täytetty ja kaikki pakolliset omavalvonnat suoritettu',
        },
      },
      tableDetails: {
        title: 'Taulukon yksityiskohdat',
        totalAmount: 'Kokonaismäärä',
        totalAmountInfo: 'Raporttien määrä projektissa',
        unexported: 'Ei viety',
        unexportedInfo: 'Valmiiden raporttien määrä, jotka voidaan viedä',
        status: 'Tila',
        statusInfo: 'Vientitila (Valmisteltu, Käynnissä, Valmis)',
        other: 'Jonossa / Viety / Epäonnistunut',
        otherInfo: 'Raporttien määrä viety',
      },
      statusForExport: {
        title: 'Viennin tila',
        READY: 'Valmisteltu',
        READYInfo: 'Tämän tyyppiset raportit ovat valmiita vietäväksi',
        IN_PROGRESS: 'Käynnissä',
        IN_PROGRESSInfo: 'Vienti suoritetaan taustalla',
        COMPLETED: 'Valmis',
        COMPLETEDInfo: 'Kaikki raportit vietiin onnistuneesti',
        NONE: '(tyhjä)',
        NONEInfo: 'Ei raportteja valmiina vientiin',
      },
    },
    overwriteReportsConfirmationModal: {
      title: 'Raportit korvataan',
      confirm: 'Vahvista vienti',
      cancel: 'Peruuta',
      body: 'Raportit, jotka on jo viety Sharepointiin, korvataan.',
    },
    loading: {
      pleaseWait: 'Ladataan sivua. Odota, ole hyvä...',
    },
    error: 'Jotain meni pieleen. Yritä uudelleen!',
    alerts: {
      exportStarted: 'Vienti aloitettu',
      exportFailed: 'Käynnistys epäonnistui. Yritä uudelleen.',
      refreshSuccess: 'HC:n päivitys onnistui',
      refreshFailed: 'HC:n päivitys epäonnistui',
    },
  },
};
